import { Component } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './email-forwarding-info.component.html',
  styleUrl: './email-forwarding-info.component.scss',
})
export class EmailForwardingInfoComponent {}
